module.exports = __webpack_public_path__ + "img/b3.d8c8ba06.png";